import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import moment from 'moment'

import config from '../../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { blockDataTransformed } from '../../../../../../../components/Workspace/components/HocBlock/actions'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.basicInformation.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(_action, 'data.data', null)
    // Transformation start
    let transformedData = _.reduce(
        data,
        (acc, row) => {
            const level = row.vlevel
            const kind = row.inacInd === '01' ? 'history' : 'active'

            const actualList = _.get(acc, `${level}.${kind}`, [])
            let date = { text: '' }
            if (row.strtDt) {
                date = {
                    text: 'dateFrom',
                    values: {
                        start: moment(row.strtDt).format('D. M. YYYY'),
                    },
                    translate: true,
                }

                if (row.endDt) {
                    date = {
                        text: 'dateFromTo',
                        values: {
                            end: moment(row.endDt).format('D. M. YYYY'),
                            start: moment(row.strtDt).format('D. M. YYYY'),
                        },
                        translate: true,
                    }
                }
            }

            const rowData = [
                {
                    text: row.typeTxt,
                },
                {
                    text: row.valueTxt,
                },
                date,
            ]

            return _.set(acc, `${level}.${kind}`, [...actualList, rowData])
        },
        {}
    )

    transformedData = _.reduce(
        transformedData,
        (acc, value, key) => {
            const levelValues = _.merge(value, { level: key })

            return [...acc, levelValues]
        },
        []
    )

    transformedData = _.sortBy(transformedData, 'level')
    // Transformation end

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    return null
}

export default function* blockTransformSaga() {
    yield all([takeEvery(BLOCK_DATA_LOADED, onDataLoaded)])
}
